import styled from '@emotion/styled'
import clsx from 'clsx'
import { TransitionStatus } from 'react-transition-group'

export const ModalContainerAnimated = styled.div<{ offsetFromBottom: number; state: TransitionStatus }>`
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  animation-duration: 500ms;

  &.entering {
    animation-name: slideModalUp;
  }
  &.exiting {
    animation-name: slideModalDown;
  }

  @media (min-width: 768px) {
    &.entering {
      animation-name: fadeModalIn;
    }

    &.exiting {
      animation-name: fadeModalOut;
    }
  }

  @keyframes fadeModalIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes fadeModalOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  @keyframes slideModalUp {
    from {
      transform: ${({ offsetFromBottom }) => `translateY(${offsetFromBottom}px)`};
    }
    to {
      transform: translateY(0px);
    }
  }

  @keyframes slideModalDown {
    from {
      transform: translateY(0px);
    }
    to {
      transform: ${({ offsetFromBottom }) => `translateY(${offsetFromBottom}px)`};
    }
  }
`

export const AnimatedBackdrop = ({
  state,
  className,
  ...props
}: { state: TransitionStatus } & React.ComponentPropsWithoutRef<'div'>) => (
  <div
    {...props}
    className={clsx(state === 'entered' || state === 'entering' ? 'bg-black-30' : 'bg-transparent', className)}
  />
)
